import tracer from 'dd-trace';
tracer.init('prod', 'spw', null, { tags: { service: 'spw' } }); // initialized in a different file to avoid hoisting.
export default tracer;